import React from 'react'
import '../styles/d3/common.scss'

const StickyHeader = props => {
  let className = 'flexed-header sticky'
  if (props.className) {
    className += ` ${props.className}`
  }
  return (
    <div
      className={className}
      style={{
        top: `${props.offset}px`
      }}>
      {props.children}
    </div>
  )
}
// }

export default StickyHeader
